module.exports = __webpack_public_path__ + "img/dbs_paylah_app.bcb5bee0.png";